import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    heading = "heading",
    heading1 = "heading1",
    buttonLabel = "buttonLabel",
    buttonLabel2 = "buttonLabel2",
    buttonLabel3 = "buttonLabel3",
    buttonLabel4 = "buttonLabel4",
    buttonBackgroundColor = "buttonBackgroundColor",
    buttonLabelColor = "buttonLabelColor",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.heading]: string;
        [fields.heading1]: string;
        [fields.buttonLabel]: string;
        [fields.buttonLabel2]: string;
        [fields.buttonLabel3]: string;
        [fields.buttonLabel4]: string;
        [fields.buttonBackgroundColor]: string;
        [fields.buttonLabelColor]: string;
    };
}

export interface Imgstyle {
    parent?: InjectableCss;
    pTitle?: InjectableCss;
    pHeading?: InjectableCss;
    Pbutton?: InjectableCss;
    btnWrapper1?: InjectableCss;
    btnWrapper2?: InjectableCss;
}

export const pageNotFoundStyle: Imgstyle = {
    parent: {
        css: css`
            border: 4px solid grayShade;
            background: rgba(38, 107, 64, 0.04);
            padding: 30px 20px;
            max-width: 750px;
            width: 100%;
            margin: 94px auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 88%;
                        margin: 54px auto;
                    `,
                    css`
                        margin: 54px auto;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },

    pTitle: {
        css: css`
            height: 50px;
            margin-bottom: 20px !important;
            font-size: ${TYPOGRAPHY.size.largest} !important;
            margin-bottom: 1rem;
            display: block;
            margin: auto;
            text-align: center;
            font-weight: ${TYPOGRAPHY.weight.black} !important;
            color: ${getProp("theme.typography.p.color")} !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        font-size: 18px !important;
                        margin-bottom: 40px !important;
                    `,
                    css``,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },

    pHeading: {
        css: css`
            font-size: ${TYPOGRAPHY.size.base} !important;
            font-weight: ${TYPOGRAPHY.weight.base} !important;
            margin-bottom: 1rem;
            display: block;
            text-align: center;
            color: ${getProp("theme.typography.p.color")} !important;
        `,
    },
    btnWrapper1: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 20px;
        `,
    },
    btnWrapper2: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 20px;
            margin-bottom: 20px;
        `,
    },
};

const styles = pageNotFoundStyle;

export const CENPagenotFound: FC<OwnProps> = ({ fields }) => {
    const Pbutton = {
        css: css`
            width: 267px;
            height: 40px;
            border-radius: 0 !important;
            padding: 0px 21px;
            font-weight: ${TYPOGRAPHY.weight.black} !important;
            background-color: ${fields.buttonBackgroundColor};
            color: ${fields.buttonLabelColor};
            border: 2px solid ${fields.buttonBackgroundColor};
        `,
    };
    const handleclick = (url: any) => {
        window.location.href = `https://centro.commerce.insitesandbox.com/${url}`;
    };
    return (
        <StyledWrapper {...styles.parent}>
            <StyledWrapper {...styles.pTitle}>{fields.title}</StyledWrapper>
            <StyledWrapper {...styles.pHeading}>{fields.heading}</StyledWrapper>
            <StyledWrapper {...styles.pHeading}>{fields.heading1}</StyledWrapper>
            <StyledWrapper {...styles.btnWrapper2}>
                <Button
                    onClick={() => {
                        handleclick("BRANDS");
                    }}
                    {...Pbutton}
                >
                    {fields.buttonLabel}
                </Button>
                <Button
                    onClick={() => {
                        handleclick("catalog");
                    }}
                    {...Pbutton}
                >
                    {fields.buttonLabel2}
                </Button>
            </StyledWrapper>
            <StyledWrapper {...styles.btnWrapper2}>
                <Button
                    onClick={() => {
                        handleclick("contact");
                    }}
                    {...Pbutton}
                >
                    {fields.buttonLabel3}
                </Button>
                <Button
                    onClick={() => {
                        handleclick(" ");
                    }}
                    {...Pbutton}
                >
                    {fields.buttonLabel4}
                </Button>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CENPagenotFound,
    definition: {
        group: "Basic",
        displayName: "PageNOTFound",
        fieldDefinitions: [
            {
                name: fields.title,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },

            {
                name: fields.heading,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.heading1,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },

            {
                fieldType: "Translatable",
                name: fields.buttonLabel,
                editorTemplate: "TextField",
                displayName: "Button Label",
                defaultValue: "",
            },

            {
                fieldType: "Translatable",
                name: fields.buttonLabel2,
                editorTemplate: "TextField",
                displayName: "Button Label1",
                defaultValue: "",
            },

            {
                fieldType: "Translatable",
                name: fields.buttonLabel3,
                editorTemplate: "TextField",
                displayName: "Button Label2",
                defaultValue: "",
            },

            {
                fieldType: "Translatable",
                name: fields.buttonLabel4,
                editorTemplate: "TextField",
                displayName: "Button Label3",
                defaultValue: "",
            },
            {
                name: fields.buttonBackgroundColor,
                editorTemplate: "TextField",
                defaultValue: "#8f0446",
                fieldType: "General",
                displayName: "Button Background Color",
            },
            {
                name: fields.buttonLabelColor,
                editorTemplate: "TextField",
                defaultValue: "white",
                fieldType: "General",
                displayName: "Button Label Color",
            },
        ],
    },
};

export default widgetModule;
